<template>
  <v-page>
    <toolbar fixed>
      <template v-slot:left>
        <span class="v-toolbar__text">{{
          $t("pages.workout.sessions.workoutResult")
        }}</span>
      </template>
    </toolbar>

    <template v-if="isLoading">
      <div class="d-flex justify-content-center py-5">
        <v-loader />
      </div>
    </template>
    <template v-else>
      <template v-if="sessions.length">
        <template v-for="session in sessions">
          <div :key="session.id" class="bg-white p-3 mb-3">
            <p class="font-weight-bold mb-3">
              {{ toDate(session.started_at) }} -
              {{ capitalizeFirstLetter(timeAgo(session.started_at)) }}
            </p>

            <div class="grid__container">
              <div
                v-if="isBeepTest && session.level"
                class="grid__stat --full-width mb-3"
              >
                <h6 class="grid__stat-title">
                  {{ $t("pages.workout.sessions.level") }}
                </h6>

                <span class="grid__stat-stat --large">
                  {{ session.level }}
                </span>
              </div>
              <div v-if="session.completed_at" class="grid__stat mb-3">
                <h6 class="grid__stat-title">
                  {{ $t("pages.workout.sessions.time") }}
                </h6>

                <span class="grid__stat-stat ">
                  {{ timeBetween(session.started_at, session.completed_at) }}
                </span>
              </div>
              <div v-if="!isBeepTest" class="grid__stat mb-3">
                <h6 class="grid__stat-title">
                  {{ $t("pages.workout.sessions.complete") }}
                </h6>

                <span class="grid__stat-stat">
                  {{ session.percent_complete }}%
                </span>
              </div>
              <div class="grid__stat mb-3">
                <h6 class="grid__stat-title">
                  {{ $t("pages.workout.sessions.startedAt") }}
                </h6>

                <span class="grid__stat-stat">
                  {{ toTime(session.started_at, "hh:mm A") }}
                </span>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="d-flex justify-content-center py-5">
          <p class="lead">{{ $t("pages.workout.sessions.noHistoryToShow") }}</p>
        </div>
      </template>
    </template>
  </v-page>
</template>

<script>
import { mapActions } from "vuex"

import { toDate, timeAgo, timeBetween, toTime } from "@/lib/date-utils"
import { capitalizeFirstLetter } from "@/lib/utils"

import Toolbar from "@/components/Toolbar"

export default {
  components: {
    Toolbar
  },

  data() {
    return {
      isLoading: false,
      sessions: [],
      workout: null
    }
  },

  computed: {
    isBeepTest() {
      return this.workout && this.workout.workout_type === "beep_test"
    }
  },

  methods: {
    ...mapActions("workouts", ["getWorkoutSessions"]),
    toDate,
    timeAgo,
    timeBetween,
    toTime,
    capitalizeFirstLetter
  },

  mounted() {
    this.isLoading = true

    this.getWorkoutSessions(this.$route.params.id).then(data => {
      this.sessions = data.sessions
      this.workout = data.workout
      this.isLoading = false
    })
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.grid__container {
  display: grid;
  grid-template-columns: 8rem auto;
  align-items: flex-end;
}

h6.grid__stat-title {
  font-weight: $font-weight--bold;
  color: $color-ui--grey-50;
  padding-bottom: $size--2;
  margin: 0;
}

.grid__stat {
  &.--full-width {
    grid-column: 1 / 3;
  }
}

.grid__stat-stat {
  font-weight: $font-weight--x-bold;
  color: $color-ui--grey-90;
  transform-origin: 0% 100%;
  transition: transform 0.2s ease, color 0.3s ease;
  min-height: 44px;
  letter-spacing: -1px;
  font-size: $font-size--h1;
  line-height: $size--8;

  &.--large {
    font-size: $font-size--display-3;
    line-height: $size--9;
  }
}
</style>
